import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import Modal from 'react-modal';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import store, { persistor } from './store/store';
import { initSentry } from 'utils/sentry';
import * as Sentry from '@sentry/react';

Modal.setAppElement('#root');
initSentry();

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
	<Provider store={store}>
		<PersistGate loading={null} persistor={persistor}>
			<Sentry.ErrorBoundary fallback={<div>Ocurrió un error inesperado. Por favor, recargá la página.</div>}>
				<App />
			</Sentry.ErrorBoundary>
		</PersistGate>
	</Provider>,
);
